import React from 'react';
import { withRouter} from 'react-router-dom';
import styles from "./styles";
import {Box, Container, Grid, IconButton, withStyles} from "@material-ui/core";
import {Info as InfoIcon} from "@material-ui/icons";

const ClaimsInstructions = (props) => {

    const { classes } = props;

        return (
            <Container className={classes.container} direction="column">

                <Grid container direction="row">
                        <Box mt={-0.625}>
                            <IconButton size='small' >
                                <InfoIcon fontSize='small' htmlColor='#297ec8'/>
                            </IconButton>
                        </Box>
                        <span>Claim Instructions:</span>
                </Grid>
                <Grid container direction="column" className={classes.instructions}>
                    <Grid xs={12} item className={classes.leftPadding}>
                        1. When a shipment is lost, damaged or delayed, insurance claims can be initiated by using Claims portal.
                    </Grid>
                    <Grid xs={12} item className={classes.leftPadding}>
                        2. From the Claims Tab, click on the “+ New Claim" button.
                    </Grid>
                    <Grid xs={12} item className={classes.leftPadding}>
                        3. In the New Claim popup, first enter a shipment ID in the search bar to find the shipment, select the shipment you want to claim, accept the terms and click “Submit” when everything is set.
                    </Grid>
                    <Grid xs={12} item className={classes.leftPadding}>
                        4. Status of any existing claim can be viewed at the Claims Page.
                    </Grid>
                    <Grid xs={12} item className={classes.extraInstructions}>
                        *For any questions related to claims, please reach out to claims@gojitsu.com.
                    </Grid>
                    <Grid xs={12} item className={classes.extraInstructions}InstructionsRow>
                        Currently only one shipment ID will be used against one claim. To initiate another claim, please repeat the steps.
                    </Grid>
                </Grid>
            </Container>
        );


}

export default withStyles(styles)(withRouter(ClaimsInstructions));
